
import * as navigate from 'app/area/shared/navigation';
import { isCaseViewModalOpen } from 'app/components/helpers';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

export const changeCaseTypeActionCreator = (
  _, 
  uiEngineProps: ConnectedComponentProps
) => {  
  const {draftId} = uiEngineProps.hostProps();
  const {location} = uiEngineProps.router ?? {};
  const favouriteId = uiEngineProps.params?.favouriteId;
  const dashboardType = uiEngineProps.params?.dashboardType;
  const bowtieCaseId = uiEngineProps.params?.bowtieCaseId;
  return {
    ...({
      onChangeCaseType: isCaseViewModalOpen() ? 
        navigate.toSelectChangeCaseType(draftId, location?.pathname, favouriteId, dashboardType, bowtieCaseId) : 
        navigate.toSelectChangeCaseType(draftId)
      
    })
  };
};
